export const getDateFromMonth = travelDate => {
  if (!travelDate) {
    return '';
  }
  const MONTHS = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
  ];
  const monthAndYear = travelDate.split(' ');
  const month = MONTHS.indexOf(monthAndYear[0]);
  const year = 20 + monthAndYear[1].slice(1);
  return new Date(year, month);
};
